type NotifyFunction = (payload: unknown) => unknown;

let _notify: NotifyFunction | null = null;

export function setNotify(fn: NotifyFunction): void {
  _notify = fn;
}

export function clearNotify(): void {
  _notify = null;
}

export function notify(payload: unknown): unknown {
  if (!_notify) return null;
  return _notify(payload);
}
